<template>
  <div class="partner">
    <div class="container">
      <div class="" v-on-scroll="{animation: 'header'}">
        <div class="back wow">
        </div>
        <h3 class="wow">Partners</h3>
      </div>
      <div class="part-cont">
        <div class="row cont-center">
          <div class="col-md-3 wow" v-on-scroll="{animation: 'partco'}">
            <div class="part">
              <img src="@/assets/gvLearning/img/01-moe-1.png">
            </div>
          </div>
          <div class="col-md-3 wow" v-on-scroll="{animation: 'partco'}">
            <div class="part">
              <img src="@/assets/gvLearning/img/2020.png">
            </div>
          </div>
          <div class="col-md-3 wow" v-on-scroll="{animation: 'partco'}">
            <div class="part">
              <img src="@/assets/gvLearning/img/03-mathnasium-1.png">
            </div>
          </div>
          <div class="col-md-3 wow" v-on-scroll="{animation: 'partco'}">
            <div class="part">
              <img src="@/assets/gvLearning/img/04-Cambridge-1.jpg">
            </div>
          </div>
          <div class="col-md-3 wow" v-on-scroll="{animation: 'partco'}">
            <div class="part">
              <img src="@/assets/gvLearning/img/05-Microsoft-1.png">
            </div>
          </div>
          <div class="col-md-3 wow" v-on-scroll="{animation: 'partco'}">
            <div class="part">
              <img src="@/assets/gvLearning/img/06-uae2pm-1.png">
            </div>
          </div>
          <div class="col-md-3 wow" v-on-scroll="{animation: 'partco'}">
            <div class="part">
              <img src="@/assets/gvLearning/img/logo-2.png">
            </div>
          </div>
          <div class="col-md-3 wow" v-on-scroll="{animation: 'partco'}">
            <div class="part">
              <img src="@/assets/gvLearning/img/Logo-B-1.png">
            </div>
          </div>
          <div class="col-md-3 wow" v-on-scroll="{animation: 'partco'}">
            <div class="part">
              <img src="@/assets/gvLearning/img/Group-2.png">
            </div>
          </div>
          <div class="col-md-3 wow" v-on-scroll="{animation: 'partco'}">
            <div class="part">
              <img src="@/assets/gvLearning/img/surface1.png">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="owl-carousel owl-theme">
        <div class="cont">
          <img src="@/assets/gvLearning/img/01-moe-1.png">
        </div>
        <div class="cont">
          <img src="@/assets/gvLearning/img/2020.png">
        </div>
        <div class="cont">
          <img src="@/assets/gvLearning/img/03-mathnasium-1.png">
        </div>
        <div class="cont">
          <img src="@/assets/gvLearning/img/04-Cambridge-1.jpg">
        </div>
        <div class="cont">
          <img src="@/assets/gvLearning/img/05-Microsoft-1.png">
        </div>
        <div class="cont">
          <img src="@/assets/gvLearning/img/06-uae2pm-1.png">
        </div>
        <div class="cont">
          <img src="@/assets/gvLearning/img/logo-2.png">
        </div>
        <div class="cont">
          <img src="@/assets/gvLearning/img/Logo-B-1.png">
        </div>
        <div class="cont">
          <img src="@/assets/gvLearning/img/Group-2.png">
        </div>
        <div class="cont">
          <img src="@/assets/gvLearning/img/surface1.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import 'owl.carousel';

export default {
  mounted() {
    this.$nextTick(() => {
      this.installOwlCarousel()
    })
  },
  methods: {
    installOwlCarousel: function () {
      window.fn = require('owl.carousel');
      $('.owl-carousel').owlCarousel(
          {
            loop: true,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: false,
            dots: true,
            navSpeed: 700,
            navText: ['', ''],
            responsive: {
              0: {
                items: 3
              },
              400: {
                items: 3
              },
              740: {
                items: 3
              },
              940: {
                items: 3
              }
            },
            nav: true
          }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@use "sass:math";
@import "~@/assets/gvLearning/styles.scss";

.partner {
  position: relative;
  padding: 100px 125px;
  @media (min-width: $width1) and (max-width: $width2) {
    padding: 60px 18px;

  }

  .header {
    /* z-index: 9999; */
    position: absolute;
    left: 37%;
    top: -150px;
    @media (min-width: $width1) and (max-width: $width2) {
      left: 14%;
      top: -110px;
    }

    .back {
      background-image: url('~@/assets/gvLearning/img/Partners.png');
      background-repeat: no-repeat;
      width: 450px;
      background-size: contain;
      height: 150px;
      animation: flipInY;
      animation-duration: 3s;
      @media (min-width: $width1) and (max-width: $width2) {
        width: 280px;
        height: 150px;
      }
    }

    h3 {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 64px;
      line-height: 69px;
      text-align: justify;
      color: #FFFFFF;
      position: absolute;
      top: 20%;
      left: 14%;
      animation: bounceIn;
      animation-duration: 5s;
      transition: all 1s ease-in-out;
      @media (min-width: $width1) and (max-width: $width2) {
        font-size: 39px;
        top: 4%;
        left: 26%;
      }
    }
  }

  .part-cont {
    padding: 0 100px;
    overflow: hidden;
    @media (min-width: $width1) and (max-width: $width2) {
      display: none;
    }

    .cont-center {
      justify-content: center;
      @for $i from 1 through 10 {
        .partco:nth-child(#{$i}) {
          animation-duration: math.div($i, 3) + s;
        }
      }

      .partco {
        animation: bounceInDown;
        transition: all 1s ease-in-out;

        .part {
          width: 100%;
          height: 69px;
          margin: 30px auto;
          padding: 0 28px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }


    }


  }

  .mobile {
    display: none;
    @media (min-width: $width1) and (max-width: $width2) {
      display: block;
    }
  }


}
</style>
